import { getMockUsers } from "./mockData";

// const BASE_URL = "https://localhost:7223/api";
const BASE_URL = "https://drdineshzirpeapi.mednexusns.com/liverhealth/api";



const handleUnauthorized = () => {
  localStorage.removeItem("token");
  alert("Session expired. Please login again.");
  window.location.href = "/login"; // Redirect to login page
};
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    handleUnauthorized();
    return null;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};
export const login = async (data) => {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    throw new Error("Invalid credentials");
  }

  return res.json();
};

export const getUsers = async () => {
  try {
    const headers = getAuthHeaders();
    if (!headers) return []; // Stop if no token

    const res = await fetch(`${BASE_URL}/assessment/users`, { headers });

    // Handle 401 Unauthorized from Server
    if (res.status === 401) {
      handleUnauthorized();
      return [];
    }

    const text = await res.text();
    return text ? JSON.parse(text) : [];
  } catch (err) {
    console.error("API failed, using mock data", err);
    return getMockUsers();
  }
};

export const getUserById = async (id) => {
  try {
    const headers = getAuthHeaders();
    if (!headers) return null;

    const res = await fetch(`${BASE_URL}/assessment/users/${id}`, { headers });

    if (res.status === 401) {
      handleUnauthorized();
      return null;
    }

    return await res.json();
  } catch (err) {
    console.error("Failed to fetch user by ID", err);
    return null;
  }
};